import React from 'react';
export function Footer() {
  return <footer className="w-full px-6 md:px-12 py-8 bg-black border-t border-white/10" data-id="element-36">
      <div className="max-w-6xl mx-auto text-center text-sm text-gray-400" data-id="element-37">
        © 2025 Cases On Command. All rights reserved.
      </div>
    </footer>;
}